module.exports = __webpack_public_path__ + "img/89.34178be1.jpg";